import type { CompanyConfigVersion } from "../../generated/core-api";
import { ProfileSummary } from "./ProfileSummary";
import s from "./SelectedCompanyConfigTemplatePreview.module.css";

interface SelectedCompanyConfigTemplatePreviewProps {
  templateVersion: CompanyConfigVersion | undefined;
  isLoading: boolean;
  isError: boolean;
  presentation: "compact" | "review";
}

export function SelectedCompanyConfigTemplatePreview({
  templateVersion,
  isLoading,
  isError,
  presentation,
}: SelectedCompanyConfigTemplatePreviewProps) {
  return (
    <section
      className={s.section}
      aria-labelledby="selected-template-preview-heading"
    >
      <h2 id="selected-template-preview-heading" className={s.heading}>
        Selected configuration template
        {templateVersion &&
          ` — ${templateVersion.display_name} (v${templateVersion.version})`}
      </h2>
      {isLoading && (
        <p className={s.status} role="status">
          Loading template details…
        </p>
      )}
      {isError && (
        <p className={s.warning} role="alert">
          Could not load the selected template&apos;s details.
        </p>
      )}
      {templateVersion && (
        <ProfileSummary
          profile={templateVersion.profile}
          presentation={presentation}
        />
      )}
    </section>
  );
}
